import { render, staticRenderFns } from "./MyExtendList.vue?vue&type=template&id=3d0980be&scoped=true"
import script from "./MyExtendList.vue?vue&type=script&lang=js"
export * from "./MyExtendList.vue?vue&type=script&lang=js"
import style0 from "./MyExtendList.vue?vue&type=style&index=0&id=3d0980be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0980be",
  null
  
)

export default component.exports